var map = {
	"./background.png": "880f",
	"./footer.png": "cf14",
	"./header.png": "ab17",
	"./scanlines_compressed.mp4": "5e5a",
	"./scanlines_original.mp4": "ec47",
	"./scanlines_trim.mp4": "579f",
	"./showcase/carousel/CONCEPT-configfile.jpg": "8d4d",
	"./showcase/carousel/CONCEPT-dragger_death_concept_01.gif": "4129",
	"./showcase/carousel/CONCEPT-enemy-design.gif": "b1e6",
	"./showcase/carousel/CONCEPT-enemy_prototype_left_with_backgrounds_and_light_shake.gif": "12d4",
	"./showcase/carousel/CONCEPT-hackktool.gif": "aec2",
	"./showcase/carousel/CONCEPT-mapscreen.jpg": "6aee",
	"./showcase/carousel/CONCEPT-monster-prototype.gif": "17f9",
	"./showcase/carousel/CONCEPT-stasis-room.jpg": "9b0a",
	"./showcase/carousel/body.png": "a190",
	"./showcase/carousel/demo_stasis_v0.gif": "8fd3",
	"./showcase/carousel/dragger-swarm.png": "54f4",
	"./showcase/carousel/enemy-attack.gif": "1858",
	"./showcase/carousel/filesystem.png": "8c8d",
	"./showcase/carousel/incinerator.png": "1f02",
	"./showcase/carousel/pal-console-talk.png": "f392",
	"./showcase/devices.gif": "b7e1",
	"./showcase/enemy-past.gif": "e08e",
	"./showcase/enemy-sneak1.gif": "b30c",
	"./showcase/hallways.gif": "ecaa",
	"./showcase/pal-conversation.gif": "c3ee",
	"./showcase/pal-file-system.gif": "46301",
	"./showcase/pal-incinerator.gif": "d2b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e75";